import { DataTableFieldsEnum } from '@shared/constants/data-pages.constant';

/**
 * Encodes the value of a document filter sent as an HTTP header
 */
export function encodeHeaderFilterValue(key: string, value: string): string {
  if (key === DataTableFieldsEnum.DashboardLabel) {
    return value
      .split(',')
      .map((label) => encodeURIComponent(label))
      .join(',');
  }
  return encodeURIComponent(value);
}
